import { Button, DrawerFooter } from 'design-system';
import { Save } from 'lucide-react';

export const DrawerFooterButtons = ({
  onSave,
  onDiscard,
  disabled
}: {
  onSave: () => void;
  onDiscard: () => void;
  disabled: boolean;
}) => (
  <DrawerFooter>
    <Button
      className='h-12'
      disabled={disabled}
      variant='outline'
      onClick={onDiscard}
    >
      Discard
    </Button>
    <Button
      className='h-12'
      disabled={disabled}
      onClick={onSave}
    >
      <Save aria-hidden='true' />
      Save
    </Button>
  </DrawerFooter>
);
